import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP = "5541988545280";

export const PLANS = [
  { id: "1-pergunta", label: "1 pergunta", price: 35, arcana: "I", name: "O Mago", note: "Uma questão direta, uma resposta clara." },
  { id: "2-perguntas", label: "2 perguntas", price: 40, arcana: "II", name: "A Sacerdotisa", note: "Duas dúvidas lidas lado a lado." },
  { id: "3-perguntas", label: "3 perguntas", price: 45, arcana: "III", name: "A Imperatriz", note: "Passado, presente e caminho." },
  { id: "meia-hora", label: "Meia hora", price: 65, arcana: "XXI", name: "O Mundo", note: "30 minutos de conversa e tiragem aberta, sem limite de perguntas." },
];

export const brl = (v) => Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Algo deu errado. Tente novamente.";
};

export const http = axios.create({ baseURL: API });
